// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import {fetchUsers} from '../../../actions/userManagement'

import UpdateUserProductsForm from '../Forms/UpdateUserProductsForm'

import './index.css'

class Products extends Component {
  componentDidMount () {
    this.props.fetchUsers()
  }

  renderUpdateUserProductsForm = () => {
    const {users} = this.props.userManagement
    if (!users) {
      return null
    }
    let forms = users.map((user) => {
      let initial_values = {
        userName: user.userName
      }

      if (user.products) {
        for (let product in user.products) {
          initial_values[product] = user.products[product]
        }
      }

      let formName = user.userName.split('@')[0]
      return (<UpdateUserProductsForm form={formName} initialValues={initial_values} key={formName} user={user}/>)
    })

    return forms
  }

  render () {
    const {user_data} = this.props.session
    if (!user_data) {
      return null
    }

    return (
      <div className='products'>
        <div className='table table-borderless row'>
          <div className='thead col-12'>
            <div className='tr row'>
              <div className='th col-2'>User</div>
              <div className='th col-2'>Multi DRM</div>
            </div>
          </div>
          <div className='tbody col-12'>
            {this.renderUpdateUserProductsForm()}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps ({session, userManagement}) {
  return {session, userManagement}
}

export default connect(mapStateToProps, {fetchUsers})(Products)
